export default "__VITE_ASSET__CkzyH9Ep__"